var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CategoryGrid',{attrs:{"image":("/" + (_vm.element.image)),"image-type":"banner_1","source":_vm.element.source,"categories":_vm.categoryWall,"mobile-title":_vm.element.mobile_title}})}
var staticRenderFns = []

export { render, staticRenderFns }